import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/firestore";
import firebase from "firebase";
import firestore = firebase.firestore;
import {COLLECTION_NAME, DOCUMENT_NAME} from "../../shared/constants";
import {SessionService} from "./session.service";
import {TargetDocName} from "../../shared/typeAliases";

@Injectable({
  providedIn: 'root'
})
export class DocNumberKanriService {

  constructor(private db: AngularFirestore,
              private sessionService: SessionService,) { }

  /**
   *
   * @param collectionName
   */
  genCustomerRootCollectionRef(collectionName: string) {
    const customerId = this.sessionService.session.personalSetting.customerId;
    return this.db.firestore.collection(COLLECTION_NAME.CUSTOMERS).doc(customerId).collection(collectionName);
  }

  /**
   * masters collection にある任意のドキュメントの ref を返す
   * @param targetDocName masters collection 配下の document 名
   */
  genTargetDocRef(targetDocName: TargetDocName) {
    return this.genCustomerRootCollectionRef(COLLECTION_NAME.MASTERS).doc(targetDocName);
  }

  /**
   * Transaction内で新しいドキュメント番号を取得
   * @param tx
   * @param targetDocName masters collection 配下の document 名
   * @param meisaiRef document 番号が連番になっている document 明細 ref
   */
  async getNewDocNumber(tx: firestore.Transaction, targetDocName: TargetDocName,
                        meisaiRef:  firebase.firestore.CollectionReference<firebase.firestore.DocumentData>) {
    /** masters collection 配下の document から docIdMax取得 **/
    const targetDocRef = this.genTargetDocRef(targetDocName);
    const targetDocSnapshot = await tx.get(targetDocRef);
    const targetDocMaxNum = targetDocSnapshot.exists ? (targetDocSnapshot.data() as {docIdMax: number}) : {docIdMax: 0};
    const docIdMax = targetDocMaxNum.docIdMax ? targetDocMaxNum.docIdMax : 0;

    // 保存されている document の中で最大の document 番号を返す。
    // 基本的には masters collection の numberDocument docIdMax と一致するはず
    const savedIdMax = await this.getSavedIdMax(targetDocName, meisaiRef);
    const currentIdMax = Math.max(docIdMax, savedIdMax);
    return currentIdMax + 1;
  }

  /**
   * document 番号が連番になっている document 明細の中で、
   * 最大の document 番号を取得
   * document が存在しない場合、0を返す
   * @param targetDocName
   * @param meisaiRef
   * @private
   */
  private async getSavedIdMax(targetDocName: TargetDocName,
                              meisaiRef:  firebase.firestore.CollectionReference<firebase.firestore.DocumentData>) {
    const propertyName = targetDocName === DOCUMENT_NAME.CHUMON_NUMBER ? 'manualChumonNumber' : targetDocName;
    const meisaiSnapshot = await meisaiRef.orderBy(propertyName, 'desc').limit(1).get();
    return !meisaiSnapshot.docs.length ? 0 : Number(meisaiSnapshot.docs[0].data()[propertyName]);
  }

  /**
   * インクリメントされた docIdMax を書き込む
   * @param tx
   * @param targetDocName
   * @param docIdMax
   */
  saveTargetDoc(tx: firestore.Transaction, targetDocName: TargetDocName, docIdMax: number) {
    const targetDocRef = this.genTargetDocRef(targetDocName);
    tx.set(targetDocRef, {docIdMax}, {merge: true});
  }
}
